import { NextImg } from '@bfa/common-ui';
import React from 'react';
import SubscribedPanel from '../SubscribedPanel';
import { StyledLeftContent, StyledRightContent, StyledSlideBackground, StyledSlideContainer, StyledSlideImage, } from './SubscribedCarouselSlide.styled';
var SubscribedCarouselSlide = function (_a) {
    var slide = _a.slide;
    var mobileBanner = slide.mobileBannerImage, desktopBanner = slide.desktopBannerImage, mobileBackground = slide.mobileBackgroundImage, desktopBackground = slide.desktopBackgroundImage;
    return (React.createElement(StyledSlideBackground, { "data-testid": "subscribed-slide-background", mobile: mobileBackground, desktop: desktopBackground },
        React.createElement(StyledSlideContainer, { "data-testid": "subscribed-slide-container" },
            React.createElement(StyledLeftContent, null, mobileBanner && (React.createElement(StyledSlideImage, { "data-testid": "subscribed-slide-image" },
                React.createElement(NextImg, { images: [
                        {
                            src: mobileBanner.src,
                            alt: mobileBanner.alt,
                            width: 2,
                            height: 3,
                        },
                        null,
                        {
                            src: desktopBanner ? desktopBanner.src : mobileBanner.src,
                            alt: desktopBanner ? desktopBanner.alt : mobileBanner.alt,
                            width: 1,
                            height: 1,
                        },
                    ], layout: "fill" })))),
            React.createElement(StyledRightContent, null,
                React.createElement(SubscribedPanel, { slide: slide })))));
};
export default SubscribedCarouselSlide;
